import { Navigate } from 'react-router-dom';

import { NavigateWithParams } from '@spacefill/shared/src/utils/RouterUtils';

const LogisticManagementStockAdjustmentByWarehouse = async () =>
    import('../../pages/inventory/stock-situation/StockAdjustment').then((module) => ({
        Component: module.LogisticManagementStockAdjustmentByWarehouse,
    }));

const LogisticManagementAccurateStockSituation = async () =>
    import('../../pages/inventory/accurate-stock-situation/index').then((module) => ({
        Component: module.LogisticManagementAccurateStockSituation,
    }));

const getStockSituationRoutes = (user) => {
    if (user?.carrierId) return [];

    return [
        {
            path: '/stock-situation/',
            lazy: LogisticManagementAccurateStockSituation,
        },
        {
            path: '/stock-situation/view/:viewId',
            lazy: LogisticManagementAccurateStockSituation,
        },
        {
            path: '/inventory/stock-situation/references/*',
            element: <Navigate to='/stock-situation/' />,
        },

        // LSP specific
        {
            path: '/inventory/stock-situation/new-adjustment/',
            lazy: LogisticManagementStockAdjustmentByWarehouse,
            condition: user.role === 'PROVIDER',
        },

        // Backwards-compatible redirects for old warehouse-prefixed URLs
        {
            path: '/warehouses/:warehouseId/stock-situation/',
            element: <NavigateWithParams to={(params) => `/stock-situation/?warehouseId=${params.warehouseId}`} />,
        },
        {
            path: '/warehouses/:warehouseId/stock-situation/view/:viewId',
            element: (
                <NavigateWithParams
                    to={(params) => `/stock-situation/view/${params.viewId}?warehouseId=${params.warehouseId}`}
                />
            ),
        },
        {
            path: '/warehouses/:warehouseId/inventory/stock-situation/references/*',
            element: <NavigateWithParams to={(params) => `/stock-situation/?warehouseId=${params.warehouseId}`} />,
        },
        {
            path: '/warehouses/:warehouseId/inventory/stock-situation/new-adjustment/',
            element: (
                <NavigateWithParams
                    to={(params) => `/inventory/stock-situation/new-adjustment/?warehouseId=${params.warehouseId}`}
                />
            ),
            condition: user.role === 'PROVIDER',
        },
    ];
};

export { getStockSituationRoutes };
